import { X } from 'lucide-react'
import { Suspense } from 'react'
import {
	Drawer,
	DrawerContent,
	DrawerTrigger,
	DrawerClose,
} from '#app/components/ui/drawer.tsx'
import { BigFivePersonalityForm } from '#app/routes/test+/big-five-personality.tsx'

interface IntakeModalProps {
	customButton: React.ReactNode
}

const IntakeModal: React.FC<IntakeModalProps> = ({ customButton }) => {
	return (
		<Drawer>
			<DrawerTrigger asChild>{customButton && customButton}</DrawerTrigger>
			<DrawerContent>
				<div className="flex cursor-pointer justify-end pr-4">
					<DrawerClose asChild>
						<X className="text-primary-400" />
					</DrawerClose>
				</div>
				<div className="mx-4 h-auto items-center justify-center gap-3 lg:mx-auto lg:w-full lg:max-w-2xl lg:pt-20 xl:max-w-3xl">
					<Suspense fallback={<div></div>}>
						<BigFivePersonalityForm />
					</Suspense>
				</div>
			</DrawerContent>
		</Drawer>
	)
}

export default IntakeModal
